// Generated by npm run icons:generate. Do not edit.
// Google Material Symbols Rounded / 400 / GRAD 0. Apache-2.0.
import { MaterialSymbol, type MaterialIconProps } from "./material-symbol";

const artwork = {
  "outline20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M480-144q-140 0-238-98t-98-238.03Q144-608 228-703t212.1-111.11Q452-816 461.5-810q9.5 6 14.58 15 5.07 9 5.5 21 .42 12-6.58 23-14 23-21.5 49.5T446-648q0 85 58.5 143.5T648-446q26.96 0 53.48-7.5Q728-461 751-475q11-7 22.5-6t20.03 6q9.47 5 15.47 14.5t4 21.5q-14 128-109.5 211.5T480-144Zm-1-72q82.92 0 148.88-46.01 65.97-46 96.12-119.99-20 5-39 8t-38 3q-114.27 0-194.64-80.48Q372-531.96 372-646.39q0-18.61 3-37.61t8-39q-74 30-120 95.93t-46 148.81Q217-369 293.73-292.5 370.46-216 479-216Zm-8-254Z"
    ]
  },
  "outline24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M480-120q-151 0-255.5-104.5T120-480q0-138 90-239.5T440-838q13-2 23 3.5t16 14.5q6 9 6.5 21t-7.5 23q-17 26-25.5 55t-8.5 61q0 90 63 153t153 63q31 0 61.5-9t54.5-25q11-7 22.5-6.5T819-479q10 5 15.5 15t3.5 24q-14 138-117.5 229T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z"
    ]
  },
  "filled20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M480-144q-140 0-238-98t-98-238q0-128 84-223t212-111q12-2 21.5 4t14.5 15q5 9 5.5 21t-6.5 23q-14 23-21.5 49.5T446-648q0 85 58.5 143.5T648-446q27 0 53.5-7.5T751-475q11-7 22.5-6t20.5 6q9 5 15 14.5t4 21.5q-14 128-109.5 211.5T480-144Z"
    ]
  },
  "filled24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M480-120q-151 0-255.5-104.5T120-480q0-138 90-239.5T440-838q13-2 23 3.5t16 14.5q6 9 6.5 21t-7.5 23q-17 26-25.5 55t-8.5 61q0 90 63 153t153 63q31 0 61.5-9t54.5-25q11-7 22.5-6.5T819-479q10 5 15.5 15t3.5 24q-14 138-117.5 229T480-120Z"
    ]
  }
} as const;

export function DarkModeIcon(props: MaterialIconProps) {
  return <MaterialSymbol {...props} symbol="dark_mode" artwork={artwork} />;
}
